import { SVGProps } from "react";

export default function SlidePrevIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 28, width = 28, fill = "#6F7782", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14 2C11.6266 2 9.30655 2.70379 7.33316 4.02236C5.35977 5.34094 3.8217 7.21508 2.91345 9.4078C2.0052 11.6005 1.76756 14.0133 2.23058 16.3411C2.6936 18.6689 3.83649 20.807 5.51472 22.4853C7.19295 24.1635 9.33115 25.3064 11.6589 25.7694C13.9867 26.2324 16.3995 25.9948 18.5922 25.0865C20.7849 24.1783 22.6591 22.6402 23.9776 20.6668C25.2962 18.6934 26 16.3734 26 14C25.9965 10.8185 24.7311 7.76825 22.4814 5.51857C20.2317 3.26889 17.1815 2.00349 14 2ZM17.3086 19.8543C17.4525 20.03 17.5215 20.2553 17.5006 20.4814C17.4798 20.7076 17.3708 20.9164 17.1971 21.0629C17.0218 21.2077 16.7963 21.2772 16.5699 21.2564C16.3434 21.2355 16.1345 21.1259 15.9886 20.9514L10.6914 14.5486C10.5627 14.3948 10.4922 14.2006 10.4922 14C10.4922 13.7994 10.5627 13.6052 10.6914 13.4514L15.9886 7.04857C16.1341 6.87353 16.3431 6.76345 16.5698 6.74255C16.7964 6.72166 17.0221 6.79165 17.1971 6.93714C17.3722 7.08263 17.4823 7.2917 17.5032 7.51835C17.5241 7.745 17.4541 7.97067 17.3086 8.14571L12.4657 14L17.3086 19.8543Z"
        fill={fill}
      />
    </svg>
  );
}
